export enum CohortFilterType {
  AllCohorts = 'ALL_COHORTS',
  YourCohorts = 'YOUR_COHORTS',
}
